var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixCashierOnboardingAvailabilityV1OnboardingAvailability from '@wix/ambassador-cashier-onboarding-availability-v1-onboarding-availability/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Status;
(function (Status) {
    Status["UNDEFINED"] = "UNDEFINED";
    Status["DECLINED"] = "DECLINED";
    Status["POSSIBLE"] = "POSSIBLE";
    Status["CONFIRMED"] = "CONFIRMED";
})(Status || (Status = {}));
export var RestrictedGoodsFlowStatus;
(function (RestrictedGoodsFlowStatus) {
    RestrictedGoodsFlowStatus["UNDEFINED"] = "UNDEFINED";
    RestrictedGoodsFlowStatus["DECLINED"] = "DECLINED";
    RestrictedGoodsFlowStatus["CONFIRMED"] = "CONFIRMED";
})(RestrictedGoodsFlowStatus || (RestrictedGoodsFlowStatus = {}));
export var RestrictedGoodsCategory;
(function (RestrictedGoodsCategory) {
    RestrictedGoodsCategory["UNDEFINED"] = "UNDEFINED";
    RestrictedGoodsCategory["TOBACCO_ALCOHOL"] = "TOBACCO_ALCOHOL";
    RestrictedGoodsCategory["FIREARMS_WEAPONS"] = "FIREARMS_WEAPONS";
    RestrictedGoodsCategory["ADULT"] = "ADULT";
    RestrictedGoodsCategory["MEDICAL"] = "MEDICAL";
    RestrictedGoodsCategory["FINANCIAL"] = "FINANCIAL";
    RestrictedGoodsCategory["TRAVEL_AGENCIES"] = "TRAVEL_AGENCIES";
    RestrictedGoodsCategory["GAMBLING_LOTTERIES_SKILL_GAMES"] = "GAMBLING_LOTTERIES_SKILL_GAMES";
    RestrictedGoodsCategory["BINARY_OPTIONS_CRYPTOCURRENCIES"] = "BINARY_OPTIONS_CRYPTOCURRENCIES";
    RestrictedGoodsCategory["MARKETPLACES"] = "MARKETPLACES";
    RestrictedGoodsCategory["OTHER"] = "OTHER";
    RestrictedGoodsCategory["CBD"] = "CBD";
    RestrictedGoodsCategory["TOBACCO_E_CIGARETTES"] = "TOBACCO_E_CIGARETTES";
    RestrictedGoodsCategory["ALCOHOL"] = "ALCOHOL";
    RestrictedGoodsCategory["NUTRACEUTICALS"] = "NUTRACEUTICALS";
})(RestrictedGoodsCategory || (RestrictedGoodsCategory = {}));
export var PartnerFlowStatus;
(function (PartnerFlowStatus) {
    PartnerFlowStatus["UNDEFINED"] = "UNDEFINED";
    PartnerFlowStatus["DECLINED"] = "DECLINED";
    PartnerFlowStatus["CONFIRMED"] = "CONFIRMED";
})(PartnerFlowStatus || (PartnerFlowStatus = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _getOnboardingAvailabilityRequest = {};
const _getOnboardingAvailabilityResponse = {};
const _updateCbdFlowRequest = {};
const _updateCbdFlowResponse = {};
const _updatePartnerFlowRequest = {};
const _updatePartnerFlowResponse = {};
const _updateRestrictedGoodsFlowRequest = {};
const _updateRestrictedGoodsFlowResponse = {};
/**
 * Fetch current state of onboarding availability for meta site.
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function getOnboardingAvailability() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getOnboardingAvailabilityRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getOnboardingAvailabilityResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['onboardingAvailability']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixCashierOnboardingAvailabilityV1OnboardingAvailability.getOnboardingAvailability(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Update current state of CBD flow for meta site.
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function updateCbdFlow(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { cbdFlow: '$[0].cbdFlow' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateCbdFlowRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateCbdFlowResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['onboardingAvailability']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixCashierOnboardingAvailabilityV1OnboardingAvailability.updateCbdFlow(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Update current state of Restricted Goods flow for meta site.
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function updateRestrictedGoodsFlow(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { restrictedGoods: '$[0].restrictedGoods' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateRestrictedGoodsFlowRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateRestrictedGoodsFlowResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['onboardingAvailability']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixCashierOnboardingAvailabilityV1OnboardingAvailability.updateRestrictedGoodsFlow(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Update current state of partner flow for meta site.
 * @public
 * @documentationMaturity preview
 * @adminMethod
 */
export function updatePartnerFlow(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { partnerFlow: '$[0].partnerFlow' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updatePartnerFlowRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updatePartnerFlowResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['onboardingAvailability']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixCashierOnboardingAvailabilityV1OnboardingAvailability.updatePartnerFlow(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=cashier-onboarding-availability-v1-onboarding-availability.universal.js.map